import { $, $$ } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-tertiary-snap-cards]')) return;

  tertiarySnapCardsDatalayer();
}

function tertiarySnapCardsDatalayer() {
  $$('[data-au-snap-card-link]').forEach((card) => {
    card.addEventListener('click', (e) => {
      const el = e.currentTarget;
      const titleText = el.closest('[data-au-tertiary-snap-cards]').querySelector('[data-au-heading-title]')
        ? `${el.closest('[data-au-tertiary-snap-cards]').querySelector('[data-au-heading-title]').innerText}_`
        : '';
      const clickText = el.closest('[data-au-snap-card]').querySelector('[data-au-snap-card-title]').innerText;
      const item_id = `${removeAccentMarkAndUppercase(titleText)}${removeAccentMarkAndUppercase(clickText)}`;

      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickCard',
        item_id,
      });
    });
  });
}

export default { init };
